import { AxiosService } from 'services';
export function UpdateUserService(id, data) {

  return AxiosService().post(`/user-page/${id}/edit-user`,data)
    .then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
}
